import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import apiManagerRoom from 'api/manager-meeting';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TOAST_DEFAULT } from 'constants/toast';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import { DIALOG_ID } from './constant';
import DialogBaseCC from './DialogBaseCC';

const DialogReject = ({
    open,
    actionText,
    actionCancelText,
    setTriggerReload,
    triggerReload,
}) => {
    const propsDialog = useLegacyDialogProps();
    const { title, roomId, nameRoom, onReject} = propsDialog
    const [contentReject, setContentReject] = useState('');
    const {t} = useTranslation()
    const reject = (data) => {
        return apiManagerRoom.statusMeeting(data);
    };
    const handleReject = () => {
        // handleClose();
        // call api
        reject({ roomId: roomId, inviteeStatus: 0, message: contentReject })
            .then((r) => {
                if (r.status === 200) {
                    toastSuccess(t('toast.rejectMeetSuccess'));
                    setContentReject('')
                    onReject()
                } else {
                    toastError(TOAST_DEFAULT.ERROR);
                }
            })
            .catch((e) => {
                console.log(e);
            });
        setCloseDialogCC()

    };
    
    return (
        <DialogBaseCC id={DIALOG_ID.REJECT_INVITE} title={title}>
            <DialogContent>
                <DialogContentText>
                    <div className="row">
                        <div className="">
                            <span style={{color: '#000'}}>{t('room.pop-up.reject.text1')} {nameRoom}?</span>
                        </div>
                    </div>
                </DialogContentText>
                <div style={{color: 'grey', fontSize: '18px', paddingBottom: '5px'}}>{t('room.pop-up.reject.text2')}</div>
                <div>
                    <input
                        style={{borderRadius: '3px', padding: '5px', width: '100%'}}
                        placeholder='Nhập lý do... '
                        maxLength={100}
                        className="reject-content"
                        value={contentReject}
                        onChange={(e) => setContentReject(e.target.value)}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => setCloseDialogCC()}>{t('room.pop-up.reject.cancel')}</Button>
                <Button onClick={handleReject}>{t('room.pop-up.reject.save')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogReject